import { Component, Input, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { IAirSector } from 'libraries/service/resources/model/search/air/IAirSector';

import { Yii } from "libraries/interfaces/Yii";
import { IGetBookingsAirResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ILabels } from 'libraries/interfaces/ILabels';

@Component({
    selector: 'booking-air',
    template: `
    <booking-header [booking]="booking" [processingId]="processingId">
        <div class="creation e2e-select-booking col-1-bottom">
            {{labels.created}} {{booking.whenCreated | dateMoment: dateFormat.momentMedium}}
            <span *ngIf="booking.agent && (booking.agent.firstName || booking.agent.lastName)">
                {{labels.by}} {{booking.agent?.firstName}} {{booking.agent?.lastName}}
            </span>
        </div>
        <div class="sector-date col-2-bottom">
            <booking-sectors *ngIf="booking.sector" [booking]="booking"></booking-sectors>
            <date-range [start]="booking.begin" [end]="booking.end"></date-range>
        </div>
    </booking-header>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        .sector-date {
          display: flex;
          flex-direction: column;
        }
    `]
})
export class BookingAirComponent implements OnChanges {

    /**
     * in case we open the booking from a processing page, modify the url and breadcrumb
     */
    @Input()
    public processingId: number;

    @Input()
    public booking: IGetBookingsAirResponse;
    public sectors: IAirSector[];

    public dateFormat = JSON.parse(sessionStorage.getItem('dateFormat'));

    public labels: ILabels = {
        created: Yii.t('wui-sasha-js', 'Créé le'),
        by: Yii.t('wui-sasha-js', 'par')
    };

    public ngOnChanges(): void {
        this.sectors = this.booking
            && this.booking.sector
            && Object.keys(this.booking.sector)
                .map((key: string) => this.booking.sector[key]);
    }
}
